import { DashboardPatientPanelFilterSection } from "./DashboardPatientPanelFilterSection";
import { DashboardPatientPanelFileFilterSection } from "./DashboardPatientPanelFileFilterSection";
import { DashboardPatientPanelPurchaseFilterSection } from "./DashboardPatientPanelPurchaseFilterSection";
import InputData from "./InputData";
import InputTextArea from "./InputTextArea";
import Dropdown from "./Dropdown";
import ButtonIconH from "./ButtonIconH";
import { useState } from "react";
import {
  userData,
  crmTypeList,
  formatValueUnit,
  focusElement,
  crmChannelOptions,
  areObjectsEqual,
  listCRMStructure,
} from "../js/utils";
import { post } from "../js/post";
import { CollapsedSection } from "./CollapsedSection";

export function CRMNewList({
  createPopupQuestion,
  removePopupQuestion,
  onClose,
}) {
  const [currentList, setCurrentList] = useState(listCRMStructure);
  const [sectionStates, setSectionStates] = useState({
    sec1: true,
    sec2: false,
    sec3: false,
  });

  // console.log("DATOS FICHA: ", currentList);

  async function createList() {
    const response = await post("support-extra/crm/CrearListaCRM.php", {
      token: userData.token,
      ...currentList,
    });
    // console.log(
      // "CREANDO LISTA: ",
      // {
        // token: userData.token,
        // ...currentList,
      // },
      // response,
    // );
    if (response.idLista !== "" && response.numPacientes !== 0) {
      createPopupQuestion(
        `La lista se ha creado con éxito con un total de ${formatValueUnit(response.numPacientes, "")} pacientes asignados.`,
        async () => {
          removePopupQuestion();
          onClose(response.idLista);
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        `Los filtros actuales no encuentran pacientes. Por favor, revíselos.`,
        removePopupQuestion,
        null,
        "Entendido",
      );
    }
  }

  return (
    <div className="popup-container">
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">Ficha de lista</span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              // console.log("CERRANDO: ", currentList, listCRMStructure);
              if (!areObjectsEqual(currentList, listCRMStructure)) {
                createPopupQuestion(
                  "Existen cambios sin guardar. ¿Desea salir de la ficha de lista?",
                  async () => {
                    removePopupQuestion();
                    onClose();
                  },
                  () => {
                    removePopupQuestion();
                  },
                  "Sí",
                  "No",
                );
              } else onClose();
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className="tab-content ap-content"
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div
            className="crm-list-container"
            style={{ maxHeight: 900, maxWidth: 1480, overflowY: "auto" }}
          >
            <div className="container-panel">
              <div className="opt-table-content grid-2" id="grid-new-list">
                <div className="cell label cell-start-content">Nombre</div>
                <div className="cell cell-start-content">
                  <InputData
                    tabIndex={10}
                    type="type-alphanum-ext"
                    size={3}
                    input={currentList.nombreLista}
                    onChange={(e) => {
                      setCurrentList((prev) => ({
                        ...prev,
                        nombreLista: e,
                      }));
                    }}
                  ></InputData>
                </div>
                <div
                  className="cell label cell-start-content"
                  style={{ alignItems: "flex-start" }}
                >
                  Descripción
                </div>
                <div className="cell">
                  <InputTextArea
                    tabIndex={11}
                    maxLength={200}
                    type="type-full"
                    size={0}
                    input={currentList.descripcion}
                    onChange={(e) => {
                      setCurrentList((prev) => ({
                        ...prev,
                        descripcion: e,
                      }));
                    }}
                  ></InputTextArea>
                </div>
                <div className="cell label cell-start-content">Tipo</div>
                <div className="cell cell-start-content">
                  <Dropdown
                    tabIndex={12}
                    optionList={crmTypeList}
                    size={3}
                    op={currentList.tipo}
                    onChange={(e) => {
                      setCurrentList((prev) => ({
                        ...prev,
                        tipo: e.id,
                      }));
                    }}
                    mandatory={false}
                  ></Dropdown>
                </div>
                <div className="cell label cell-start-content">Canal</div>
                <div className="cell cell-start-content">
                  <Dropdown
                    tabIndex={13}
                    optionList={crmChannelOptions}
                    size={3}
                    op={currentList.canal}
                    onChange={(e) => {
                      setCurrentList((prev) => ({
                        ...prev,
                        canal: e.id,
                      }));
                    }}
                    mandatory={false}
                  ></Dropdown>
                </div>
              </div>
            </div>
            <div className="container-panel">
              {!sectionStates.sec1 && (
                <CollapsedSection
                  title="Filtros generales"
                  status={sectionStates.sec1}
                  onClick={() => {
                    setSectionStates((prev) => ({
                      ...prev,
                      sec1: !prev.sec1,
                    }));
                  }}
                />
              )}
              {sectionStates.sec1 && (
                <DashboardPatientPanelFilterSection
                  status={sectionStates.sec1}
                  onClick={() => {
                    setSectionStates((prev) => ({
                      ...prev,
                      sec1: !prev.sec1,
                    }));
                  }}
                  onChange={(e) => {
                    setCurrentList((prev) => ({
                      ...prev,
                      filtrosGenerales: e,
                    }));
                  }}
                />
              )}
            </div>
            <div className="container-panel">
              {!sectionStates.sec2 && (
                <CollapsedSection
                  title="Filtros de ficha"
                  status={sectionStates.sec2}
                  onClick={() => {
                    setSectionStates((prev) => ({
                      ...prev,
                      sec2: !prev.sec2,
                    }));
                  }}
                />
              )}
              {sectionStates.sec2 && (
                <DashboardPatientPanelFileFilterSection
                  status={sectionStates.sec2}
                  createPopupQuestion={createPopupQuestion}
                  removePopupQuestion={removePopupQuestion}
                  onClick={() => {
                    setSectionStates((prev) => ({
                      ...prev,
                      sec2: !prev.sec2,
                    }));
                  }}
                  onChange={(e) => {
                    setCurrentList((prev) => ({
                      ...prev,
                      filtrosFicha: e,
                    }));
                  }}
                />
              )}
            </div>
            <div className="container-panel">
              {!sectionStates.sec3 && (
                <CollapsedSection
                  title="Filtros de compra"
                  status={sectionStates.sec3}
                  onClick={() => {
                    setSectionStates((prev) => ({
                      ...prev,
                      sec3: !prev.sec3,
                    }));
                  }}
                />
              )}
              {sectionStates.sec3 && (
                <DashboardPatientPanelPurchaseFilterSection
                  status={sectionStates.sec3}
                  onClick={() => {
                    setSectionStates((prev) => ({
                      ...prev,
                      sec3: !prev.sec3,
                    }));
                  }}
                  onChange={(e) => {
                    setCurrentList((prev) => ({
                      ...prev,
                      filtrosCompra: e,
                    }));
                  }}
                />
              )}
            </div>
            <div
              className="container-panel"
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ButtonIconH
                text="Nueva lista"
                onClick={async () => {
                  if (currentList.nombreLista === "") {
                    createPopupQuestion(
                      `Por favor, introduzca un nombre para la lista.`,
                      () => {
                        focusElement(10);
                        removePopupQuestion();
                      },
                      null,
                      "Entendido",
                    );
                  } else {
                    await createList();
                  }
                }}
              ></ButtonIconH>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
